import React from 'react';
import { message, PageHeader, Icon, Divider, Button, Input, Form, Select, Spin, Row, Col, Checkbox, Switch, InputNumber } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import PaginationBase from '../../common/base/PaginationBase';
import dialog from '../../common/utility/dialog';
import estadoMock from '../../common/mock/estadoMock';
import { GREATER_THAN_ZERO } from '../../common/types/regularExpresionType';
import { RUC, DNI } from '../../common/types/tipoDocumentoType';
import { HABIDO } from '../../common/types/condicionSunatType';
import { ACTIVO } from '../../common/types/estadoContribuyenteType';
import { JURIFICA } from '../../common/types/tipoPersonaType';

import empresaService from '../../service/administracion/empresaService';
import padronReducidoService from '../../service/integracion/padronReducidoService';
import tipoPersonaService from '../../service/administracion/tipoPersonaService';
import tipoDocumentoService from '../../service/administracion/tipoDocumentoService';
import condicionSunatService from '../../service/administracion/condicionSunatService';
import estadoContribuyenteService from '../../service/administracion/estadoContribuyenteService';
import tipoRelacionService from '../../service/administracion/tipoRelacionService';
import ubigeoService from '../../service/integracion/ubigeoService';
import File from './File';
import { DOMICILIO_FISCAL } from '../../common/types/tipoEstablecimientoType';
import global from '../../common/utility/global';
import tipoRegimenService from '../../service/administracion/tipoRegimenService';
import { lst_tipo_impuesto } from '../../common/types/impuestoType';
import { lst_tipo_empresa } from '../../common/types/tipoEmpresaType';
import printFormatMock from '../../common/mock/printFormatMock';


const { Option } = Select;
const { Search } = Input;

class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            estados: estadoMock.values,
            tiposPersona: [],
            tiposDocumento: [],
            condicionesSunat: [],
            estadosContribuyente: [],
            tiposRegimen: [],
            tiposRelacion: [],
            vendedores: [],
            departamentos: [],
            provincias: [],
            distritos: [],
            tipoImpuestos: [],
            tipoEmpresas: [],
            formatoPrints: printFormatMock.values,
            formValues: this.fetchEmptyFormValues()
        }
    }

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            idTipoPersona: 0,
            idTipoDocumento: 0,
            numeroDocumento: '',
            razonSocial: '',
            cuentaBancaria: '',
            nombre: '',
            apellidoPaterno: '',
            apellidoMaterno: '',
            correo: '',
            web: '',
            webSiteComprobante: '',
            numeroResolucion: '',
            idEstadoContribuyente: 0,
            idCondicionSunat: 0,
            idTipoRelacion: 0,
            nombreTipoEstablecimiento: '',
            telefono: '',
            idDepartamento: 0,
            idProvincia: 0,
            idUbigeo: 0,
            direccion: '',
            flagRetencion: false,
            flagAmazonia: false,
            porcentajeRetencion: 0,
            porcentajeCajaChica: 0,
            /******************/
            searchLoading: false,
            flagPersonaJuridica: true,
            idTipoImpuesto: 1,
            idTipoEmpresa: 0,
        }
    };

    handleSave = (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {

            var response;
            response = await empresaService.modificar(values);
            if (response.status === 200) {
                message.success('Modificado correctamente.');
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleValidForm = () => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {

                const form = {
                    id: values.id,
                    idTipoPersona: values.idTipoPersona.key,
                    idTipoDocumento: values.idTipoDocumento.key,
                    numeroDocumento: values.numeroDocumento,
                    razonSocial: values.razonSocial,
                    cuentaBancaria: values.cuentaBancaria,
                    nombre: values.nombre,
                    apellidoPaterno: values.apellidoPaterno,
                    apellidoMaterno: values.apellidoMaterno,
                    idCondicionSunat: values.idCondicionSunat.key,
                    idEstadoContribuyente: values.idEstadoContribuyente.key,
                    idTipoRegimen: values.idTipoRegimen.key,
                    idTipoRelacion: values.idTipoRelacion === undefined ? 0 : values.idTipoRelacion.key,
                    correo: values.correo,
                    web: values.web,
                    webSiteComprobante: values.webSiteComprobante,
                    urlImagen: values.urlImagen,
                    nombreImagen: values.nombreImagen,
                    numeroResolucion: values.numeroResolucion,
                    idTipoEstablecimiento: DOMICILIO_FISCAL.ID,
                    idUbigeo: values.idUbigeo.key,
                    telefono: values.telefono,
                    direccion: values.direccion,
                    flagRetencion: values.flagRetencion,
                    flagAmazonia: values.flagAmazonia,
                    porcentajeCajaChica: values.porcentajeCajaChica === undefined ? 0 : parseFloat(values.porcentajeCajaChica),
                    porcentajeRetencion: 0,
                    descripcionRetencion: values.flagRetencion ? values.descripcionRetencion : null,
                    condicionComercial: values.condicionComercial,
                    idTipoImpuesto: values.idTipoImpuesto.key,
                    idTipoEmpresa: values.idTipoEmpresa.key,
                    formatoPrint: values.formatoPrint.key,
                };
                this.handleSave(form, this.props.form);
            }
        });
    }

    handleBuscarPadronReducido = async (idTipoDocumento, numeroDocumento, form) => {
        this.setState({ formValues: { ...this.state.formValues, searchLoading: true } });
        const response = await padronReducidoService.entidad({ idTipoDocumento, numeroDocumento });

        if (response.status === 200) {
            const provincias = await ubigeoService.provincias(response.data.idDepartamento);
            const distritos = await ubigeoService.distritos(response.data.idProvincia);
            this.setState({
                provincias,
                distritos,
                formValues: {
                    ...this.state.formValues,
                    searchLoading: false
                }
            }, () => {
                form.setFieldsValue({
                    razonSocial: response.data.razonSocial,
                    nombre: response.data.nombre,
                    apellidoMaterno: response.data.apellidoMaterno,
                    apellidoPaterno: response.data.apellidoPaterno,
                    idCondicionSunat: { key: response.data.idCondicionSunat },
                    idEstadoContribuyente: { key: response.data.idEstadoContribuyente },
                    idDepartamento: { key: response.data.idDepartamento },
                    idProvincia: { key: response.data.idProvincia },
                    idUbigeo: { key: response.data.idUbigeo },
                    direccion: response.data.direccion,
                });
            });
        }
        else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    searchLoading: false
                }
            });
        }
    };

    handleChangeForm = async (property, value) => {
        if (property === "idDepartamento") {
            const provincias = await ubigeoService.provincias(value);
            this.setState({
                provincias: provincias ? provincias : [],
                distritos: []
            });
        }

        if (property === "idProvincia") {
            const distritos = await ubigeoService.distritos(value);
            this.setState({
                distritos: distritos ? distritos : []
            });
        }

        if (property === "clear") {
            this.setState({
                provincias: [],
                distritos: []
            });
        }
    };

    handleChangeTipoPersona = (option, item) => {
        this.props.form.setFieldsValue({
            flagPersonaJuridica: item.props.data === JURIFICA.CODIGO ? true : false,
            idTipoDocumento: undefined,
            numeroDocumento: '',
            razonSocial: '',
            nombre: '',
            apellidoPaterno: '',
            apellidoMaterno: '',
            idCondicionSunat: { key: HABIDO },
            idEstadoContribuyente: { key: ACTIVO },
            idDepartamento: undefined,
            idProvincia: undefined,
            idUbigeo: undefined,
            direccion: '',
        }, () => {
            this.handleChangeForm("clear");
        });
    }

    numeroDocumentoCustomValidation = (rule, value, callback) => {
        var idTipoDocumento = this.props.form.getFieldValue('idTipoDocumento')?.key;
        var numeroDocumentoLongitud = this.props.form.getFieldValue('numeroDocumento')?.length;
        var longitud = idTipoDocumento === RUC.ID ? 11 : 8;

        if ([RUC.ID, DNI.ID].includes(idTipoDocumento) &&
            numeroDocumentoLongitud !== longitud &&
            numeroDocumentoLongitud > 0)
            callback('La longitud de ser de ' + longitud + ' caracteres.');

        callback();
    }

    handleChangeFile = async (event) => {

        var file = event.target.files[0];
        if (!file)
            return;

        var fileExtension = file.name.split('.')[1];
        var fileSize = Math.floor(file.size / 1024);
        var allowedExtensions = ['jpeg', 'jpg', 'png'];

        if (allowedExtensions.filter(m => { return m === fileExtension }).length === 0) {
            message.error('Solo puede subir archivos: ' + allowedExtensions.join(' / ') + '.');
            return;
        }

        if (fileSize > 5120) {
            message.error('Tamaño máximo permitido ' + parseFloat(parseFloat(fileSize / 1024).toFixed(2)).toString() + ' mb.');
            return;
        }

        this.props.form.setFieldsValue({ nombreImagen: file.name, icon: 'loading' });

        var response = await empresaService.subirImagen(file);

        if (response.status !== 200) {
            message.error('Ocurrió un error al intentar subir el archivo.');
            this.handleRemoveFile();
            return;
        }

        this.props.form.setFieldsValue({ icon: 'folder-open', urlImagen: response.data.url });
    }

    handleRemoveFile = () => {

        global.cleanInputFile(this.props.form.getFieldValue('identifier'), this.handleChangeFile);
        this.props.form.setFieldsValue({ urlImagen: '', nombreImagen: '', icon: 'folder-open' });
    }

    async componentDidMount() {
        const empresa = await empresaService.obtenerPrincipal(0);
        const tiposPersona = await tipoPersonaService.listar();
        const tiposDocumento = await tipoDocumentoService.listar();
        const condicionesSunat = await condicionSunatService.listar();
        const estadosContribuyente = await estadoContribuyenteService.listar();
        const tiposRegimen = await tipoRegimenService.listar();
        const departamentos = await ubigeoService.departamentos();
        const tiposRelacion = await tipoRelacionService.listar();
        const provincias = await ubigeoService.provincias(empresa.idDepartamento);
        const distritos = await ubigeoService.provincias(empresa.idProvincia);

        this.setState({
            loading: false,
            tiposPersona: tiposPersona ? tiposPersona : [],
            tiposDocumento: tiposDocumento ? tiposDocumento : [],
            condicionesSunat: condicionesSunat ? condicionesSunat : [],
            estadosContribuyente: estadosContribuyente ? estadosContribuyente : [],
            tiposRegimen: tiposRegimen ? tiposRegimen : [],
            tiposRelacion: tiposRelacion ? tiposRelacion : [],
            departamentos: departamentos ? departamentos : [],
            provincias: provincias ? provincias : [],
            distritos: distritos ? distritos : [],
            tipoImpuestos: lst_tipo_impuesto,
            tipoEmpresas: lst_tipo_empresa,

            formValues: {
                ...empresa,
                flagPersonaJuridica: empresa.codigoTipoPersona === JURIFICA.CODIGO ? true : false,
            }
        });
    };

    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        getFieldDecorator('id', { initialValue: this.state.formValues.id });
        getFieldDecorator('flagPersonaJuridica', { initialValue: this.state.formValues.flagPersonaJuridica });
        getFieldDecorator('identifier', { initialValue: 'file-1' });
        getFieldDecorator('urlImagen', { initialValue: this.state.formValues.urlImagen });
        getFieldDecorator('nombreImagen', { initialValue: this.state.formValues.nombreImagen });
        getFieldDecorator('icon', { initialValue: 'folder-open' });


        getFieldDecorator('razonSocial', { initialValue: '' });
        getFieldDecorator('nombre', { initialValue: '' });
        getFieldDecorator('apellidoPaterno', { initialValue: '' });
        getFieldDecorator('apellidoMaterno', { initialValue: '' });

        return (
            <div>
                <PageHeader
                    title={<div><Icon type="container" />&nbsp;&nbsp;Mi Empresa</div>}
                    extra={[
                        <div key="1">
                            <Button
                                ghost
                                icon="save"
                                type="primary"
                                loading={this.state.loading}
                                onClick={() => this.handleValidForm()}
                            >
                                Guardar
                            </Button>
                        </div>
                    ]}
                />
                <Divider />
                <Spin tip="Cargando..." size="large" spinning={this.state.loading}>
                    <Form>
                        <Row gutter={16}>
                            <Col className="gutter-row" sm={24} md={8} lg={6} xl={5}>
                                <Form.Item label="Tipo de Persona">
                                    {getFieldDecorator('idTipoPersona', {
                                        initialValue: this.state.formValues.idTipoPersona ? { key: this.state.formValues.idTipoPersona } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Campo obligatorio.'
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Tipo de Persona"}
                                            optionFilterProp="children"
                                            onChange={this.handleChangeTipoPersona}
                                        >
                                            {this.state.tiposPersona.map(item => (
                                                <Option key={item.id} value={item.id} data={item.codigo}>{item.nombre}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" sm={24} md={8} lg={6} xl={5}>
                                <Form.Item label="Tipo de Documento">
                                    {getFieldDecorator('idTipoDocumento', {
                                        initialValue: this.state.formValues.idTipoDocumento ?
                                            { key: this.state.formValues.idTipoDocumento } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Campo obligatorio.'
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Tipo de Documento"}
                                            optionFilterProp="children"
                                            onChange={this.handleChangeTipoDocumento}
                                        >
                                            {
                                                (this.props.form.getFieldValue('flagPersonaJuridica') ?
                                                    this.state.tiposDocumento.filter(m => m.id === RUC.ID) :
                                                    this.state.tiposDocumento.filter(m => m.id !== RUC.ID))
                                                    .map(item => (
                                                        <Option key={item.id} value={item.id} data={item.codigo}>{item.abreviatura}</Option>
                                                    ))
                                            }
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" sm={24} md={8} lg={6} xl={5}>
                                <Form.Item label="Número Documento">
                                    {getFieldDecorator('numeroDocumento', {
                                        initialValue: this.state.formValues.numeroDocumento,
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Campo obligatorio.',
                                                whitespace: true,
                                            },
                                            {
                                                validator: this.numeroDocumentoCustomValidation
                                            }
                                        ]
                                    })(
                                        <Search
                                            placeholder="Búsqueda por Documento"
                                            autoComplete="off"
                                            maxLength={20}
                                            loading={this.state.formValues.searchLoading}
                                            onSearch={value => this.handleBuscarPadronReducido(this.props.form.getFieldValue('idTipoDocumento').key, value, this.props.form)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row >

                        {
                            !this.props.form.getFieldValue('flagPersonaJuridica') ? null :
                                <Row gutter={16}>
                                    <Col className="gutter-row" sm={24} md={24} lg={18} xl={15}>
                                        <Form.Item label="Razón Social">
                                            {getFieldDecorator('razonSocial', {
                                                initialValue: this.state.formValues.razonSocial,
                                                rules: [{
                                                    required: this.props.form.getFieldValue('flagPersonaJuridica'),
                                                    message: 'Campo obligatorio.',
                                                    whitespace: true
                                                }]
                                            })(
                                                <Input
                                                    placeholder="Ingresar Razón Social"
                                                    autoComplete="off"
                                                />
                                            )}
                                        </Form.Item>
                                    </Col>

                                </Row>
                        }

                        {
                            this.props.form.getFieldValue('flagPersonaJuridica') ? null :
                                <Row gutter={16}>
                                    <Col className="gutter-row" sm={24} md={24} lg={18} xl={15}>
                                        <Form.Item label="Nombre">
                                            {getFieldDecorator('nombre', {
                                                initialValue: this.state.formValues.nombre,
                                                rules: [{
                                                    required: !this.props.form.getFieldValue('flagPersonaJuridica'),
                                                    message: 'Campo obligatorio.',
                                                    whitespace: true
                                                }]
                                            })(
                                                <Input
                                                    placeholder="Ingresar nombre"
                                                    autoComplete="off"
                                                />
                                            )}
                                        </Form.Item>
                                    </Col>

                                </Row>
                        }

                        {
                            this.props.form.getFieldValue('flagPersonaJuridica') ? null :
                                <Row gutter={16}>
                                    <Col className="gutter-row" sm={24} md={12} lg={9} xl={7}>
                                        <Form.Item label="Apellido Paterno">
                                            {getFieldDecorator('apellidoPaterno', {
                                                initialValue: this.state.formValues.apellidoPaterno,
                                                rules: [{
                                                    required: !this.props.form.getFieldValue('flagPersonaJuridica'),
                                                    message: 'Campo obligatorio.',
                                                    whitespace: true
                                                }]
                                            })(
                                                <Input
                                                    placeholder="Ingresar Apellido Paterno"
                                                    autoComplete="off"
                                                />
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col className="gutter-row" sm={24} md={12} lg={9} xl={8}>
                                        <Form.Item label="Apellido Materno">
                                            {getFieldDecorator('apellidoMaterno', {
                                                initialValue: this.state.formValues.apellidoMaterno,
                                                rules: [{
                                                    required: !this.props.form.getFieldValue('flagPersonaJuridica'),
                                                    message: 'Campo obligatorio.',
                                                    whitespace: true
                                                }]
                                            })(
                                                <Input
                                                    placeholder="Ingresar Apellido Materno"
                                                    autoComplete="off"
                                                />
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                        }

                        <Row gutter={16}>
                            <Col className="gutter-row" sm={24} md={12} lg={9} xl={5}>
                                <Form.Item label="Condición Sunat">
                                    {getFieldDecorator('idCondicionSunat', {
                                        initialValue: this.state.formValues.idCondicionSunat ?
                                            { key: this.state.formValues.idCondicionSunat } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Campo obligatorio.',
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Condición Sunat"}
                                            optionFilterProp="children"
                                        >
                                            {this.state.condicionesSunat.map(item => (
                                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" sm={24} md={12} lg={9} xl={5}>
                                <Form.Item label="Estado Contribuyente">
                                    {getFieldDecorator('idEstadoContribuyente', {
                                        initialValue: this.state.formValues.idEstadoContribuyente ?
                                            { key: this.state.formValues.idEstadoContribuyente } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Campo obligatorio.',
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Estado Contribuyente"}
                                            optionFilterProp="children"
                                        >
                                            {this.state.estadosContribuyente.map(item => (
                                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" sm={24} md={12} lg={9} xl={5}>
                                <Form.Item label="Tipo Régimen">
                                    {getFieldDecorator('idTipoRegimen', {
                                        initialValue: this.state.formValues.idTipoRegimen ?
                                            { key: this.state.formValues.idTipoRegimen } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Campo obligatorio.',
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Tipo Régimen"}
                                            optionFilterProp="children"
                                        >
                                            {this.state.tiposRegimen.map(item => (
                                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col className="gutter-row" sm={24} md={12} lg={9} xl={7}>
                                <Form.Item label="Web">
                                    {getFieldDecorator('web', {
                                        initialValue: this.state.formValues.web,
                                    })(
                                        <Input
                                            placeholder="Ingresar Web"
                                            autoComplete="off"
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" sm={24} md={12} lg={9} xl={8}>
                                <Form.Item label="Correo">
                                    {getFieldDecorator('correo', {
                                        initialValue: this.state.formValues.correo,
                                    })(
                                        <Input
                                            placeholder="Ingresar Correo"
                                            autoComplete="off"
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col className="gutter-row" sm={24} md={24} lg={18} xl={15}>
                                <Form.Item label="Cuenta Bancaria">
                                    {getFieldDecorator('cuentaBancaria', {
                                        initialValue: this.state.formValues.cuentaBancaria,
                                    })(
                                        <TextArea
                                            placeholder="Ingresar Nro Cuenta Bancaria"
                                            rows={5}
                                            autoComplete="off"
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            {/* <Col className="gutter-row" sm={24} md={12} lg={9} xl={7}>
                                <Form.Item label="Web Site Comprobante">
                                    {getFieldDecorator('webSiteComprobante', {
                                        initialValue: this.state.formValues.webSiteComprobante,
                                    })(
                                        <Input
                                            placeholder="Ingresar Web Site Comprobante"
                                            autoComplete="off"
                                        />
                                    )}
                                </Form.Item>
                            </Col> */}
                            <Col className="gutter-row" sm={24} md={12} lg={9} xl={5}>
                                <Form.Item label="Nro Resolución">
                                    {getFieldDecorator('numeroResolucion', {
                                        initialValue: this.state.formValues.numeroResolucion,
                                    })(
                                        <Input
                                            placeholder="Ingresar Nro Resolución"
                                            autoComplete="off"
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                            <Col className="gutter-row" sm={24} md={12} lg={9} xl={3}>
                                <Form.Item label="% Efectivo de la Caja">
                                    {getFieldDecorator('porcentajeCajaChica', {
                                        initialValue: this.state.formValues.porcentajeCajaChica,
                                    })(

                                        <InputNumber
                                            defaultValue={this.state.formValues.porcentajeCajaChica}
                                            min={0}
                                            max={100}
                                            formatter={value => `${value}%`}
                                            parser={value => value.replace('%', '')}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" sm={24} md={12} lg={9} xl={7}>
                                <Form.Item label="Tipo de empresa">
                                    {getFieldDecorator('idTipoEmpresa', {
                                        initialValue: {
                                            key: this.state.formValues.idTipoEmpresa != null
                                                ? String(this.state.formValues.idTipoEmpresa)
                                                : "0"
                                        },
                                        rules: [{
                                            required: true,
                                            message: 'Campo obligatorio.',
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Tipo de empresa"}
                                            optionFilterProp="children"
                                        >
                                            <Option key="0" value="0">
                                                <span style={{ color: "#bfbfbf" }}>Ninguno</span>
                                            </Option>
                                            {this.state.tipoEmpresas.map(item => (
                                                <Option
                                                    key={String(item.id)}
                                                    value={String(item.id)}
                                                >
                                                    {item.nombre}
                                                </Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>

                            <Col className="gutter-row" sm={24} md={12} lg={9} xl={5}>
                                <Form.Item label="Formato Impresión">
                                    {getFieldDecorator('formatoPrint', {
                                        initialValue: this.state.formValues.formatoPrint ?
                                            { key: this.state.formValues.formatoPrint } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Campo obligatorio.',
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Formato Impresión"}
                                            optionFilterProp="children"
                                        >

                                            {this.state.formatoPrints.map(item => (
                                                <Option
                                                    key={item.id}
                                                    value={item.id}
                                                >
                                                    {item.nombre}
                                                </Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16} className="mt-10">
                            <Col className="gutter-row" sm={24} md={24} lg={18} xl={15}>
                                <span style={{ fontWeight: '500' }}>Datos de Dirección</span>
                            </Col>
                        </Row>
                        <Row gutter={16} className="mt-10">
                            <Col className="gutter-row" sm={24} md={24} lg={18} xl={15}>
                                <Divider style={{ marginTop: '0px' }} />
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col className="gutter-row" sm={24} md={12} lg={9} xl={7}>
                                <Form.Item label="Tipo Establecimiento">
                                    {getFieldDecorator('nombreTipoEstablecimiento', {
                                        initialValue: this.state.formValues.nombreTipoEstablecimiento
                                    })(
                                        <Input disabled autoComplete="off" />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" sm={24} md={12} lg={9} xl={4}>
                                <Form.Item label="Teléfono">
                                    {getFieldDecorator('telefono', {
                                        initialValue: this.state.formValues.telefono,
                                    })(
                                        <Input
                                            placeholder="Ingresar Teléfono"
                                            autoComplete="off"
                                            maxLength="150"
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                            <Col className="gutter-row" sm={24} md={8} lg={5} xl={4}>
                                <Form.Item label="Tipo Impuesto">
                                    {getFieldDecorator('idTipoImpuesto', {
                                        initialValue: this.state.formValues.idTipoImpuesto ?
                                            { key: this.state.formValues.idTipoImpuesto } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Campo obligatorio.',
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Tipo Impuesto"}
                                            optionFilterProp="children"
                                        >
                                            {this.state.tipoImpuestos.map(item => (
                                                <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col className="gutter-row" sm={24} md={8} lg={6} xl={5}>
                                <Form.Item label="Departamento">
                                    {getFieldDecorator('idDepartamento', {
                                        initialValue: this.state.formValues.idDepartamento ? { key: this.state.formValues.idDepartamento } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Campo obligatorio.',
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione departamento"}
                                            optionFilterProp="children"
                                            onChange={(option) => {
                                                this.props.form.setFieldsValue({ idProvincia: undefined });
                                                this.props.form.setFieldsValue({ idUbigeo: undefined });
                                                this.handleChangeForm("idDepartamento", option.key)
                                            }}
                                        >
                                            {this.state.departamentos.map(item => (
                                                <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" sm={24} md={8} lg={6} xl={5}>
                                <Form.Item label="Provincia">
                                    {getFieldDecorator('idProvincia', {
                                        initialValue: this.state.formValues.idProvincia ?
                                            { key: this.state.formValues.idProvincia } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Campo obligatorio.',
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione provincia"}
                                            optionFilterProp="children"
                                            onChange={(option) => {
                                                this.props.form.setFieldsValue({ idUbigeo: undefined });
                                                this.handleChangeForm("idProvincia", option.key)
                                            }}
                                        >
                                            {this.state.provincias.map(item => (
                                                <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" sm={24} md={8} lg={6} xl={5}>
                                <Form.Item label="Distrito">
                                    {getFieldDecorator('idUbigeo', {
                                        initialValue: this.state.formValues.idUbigeo ?
                                            { key: this.state.formValues.idUbigeo } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Campo obligatorio.',
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione distrito"}
                                            optionFilterProp="children"
                                        >
                                            {this.state.distritos.map(item => (
                                                <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row >

                        <Row gutter={16}>
                            <Col className="gutter-row" sm={24} md={24} lg={18} xl={15}>
                                <Form.Item label="Dirección">
                                    {getFieldDecorator('direccion', {
                                        initialValue: this.state.formValues.direccion,
                                        rules: [{
                                            required: true,
                                            message: 'Campo obligatorio.',
                                            whitespace: true
                                        }]
                                    })(
                                        <Input
                                            placeholder="Ingresar Dirección"
                                            autoComplete="off"
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" sm={24} md={24} lg={18} xl={15}>
                                <Form.Item label="¿BIENES O SERVICIOS PRESTADOS EN LA AMAZONÍA PARA SER CONSUMIDOS EN LA MISMA?">
                                    {getFieldDecorator('flagAmazonia', {
                                        initialValue: this.state.formValues.flagAmazonia,
                                        valuePropName: 'checked'
                                    })(
                                        <Switch checkedChildren="SI" unCheckedChildren="NO"
                                            onChange={(e) => this.handleChangeForm("flagAmazonia", e, this.props.form)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16} >
                            <Col className="gutter-row" sm={24} md={24} lg={18} xl={2}>

                                <Form.Item label="Agente Retendor">
                                    {getFieldDecorator('flagRetencion', {
                                        initialValue: this.state.formValues.flagRetencion,
                                        valuePropName: 'checked'
                                    })(
                                        <Switch checkedChildren="SI" unCheckedChildren="NO"
                                            onChange={(e) => this.handleChangeForm("flagRetencion", e, this.props.form)}
                                        />
                                    )}
                                </Form.Item>

                            </Col>


                            {
                                !this.props.form.getFieldValue('flagRetencion') ? null :
                                    <Col className="gutter-row" sm={24} md={24} lg={18} xl={12}>
                                        <Form.Item label="Descripción Retención">
                                            {getFieldDecorator('descripcionRetencion', {
                                                initialValue: this.state.formValues.descripcionRetencion,
                                                rules: [{
                                                    required: this.props.form.getFieldValue('flagRetencion'),
                                                    message: 'Campo obligatorio.',
                                                    whitespace: true
                                                }]
                                            })(
                                                <Input
                                                    placeholder="Ingresar Descripción Retención"
                                                    autoComplete="off"
                                                />
                                            )}
                                        </Form.Item>
                                    </Col>
                            }
                        </Row>

                        <Row gutter={16}>
                            <Col className="gutter-row" sm={24} md={24} lg={18} xl={15}>
                                <Form.Item label="Condición Comercial">
                                    {getFieldDecorator('condicionComercial', {
                                        initialValue: this.state.formValues.condicionComercial,
                                        rules: [{
                                            message: 'Campo obligatorio.',
                                            whitespace: true
                                        }]
                                    })(
                                        <Input
                                            placeholder="Ingresar Condición Comercial"
                                            autoComplete="off"
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col className="gutter-row" sm={24} md={24} lg={18} xl={15}>
                                <Form.Item label="Imagen">
                                    <File
                                        identifier={getFieldValue('identifier')}
                                        filename={getFieldValue('nombreImagen')}
                                        downloadUrl={getFieldValue('urlImagen')}
                                        icon={getFieldValue('icon')}
                                        onChange={this.handleChangeFile}
                                        onRemove={this.handleRemoveFile}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Spin>
            </div>
        )
    }
}
export default Form.create()(Index)